import React from 'react'

import { IntroBlockFooter } from './IntroBlockFooter/IntroBlockFooter'
import { IntroBlockHeader } from './IntroBlockHeader/IntroBlockHeader'

import s from './DomainOrSkillIntroBlock.module.scss'

export type DomainOrSkillIntroBlockProps = {
  name: string
  icon: string
  clientReviewsCount: number
  developersCount: number
  rating: number
}

export const DomainOrSkillIntroBlock: React.FC<
  DomainOrSkillIntroBlockProps
> = ({ name, icon, clientReviewsCount, developersCount, rating }) => {
  return (
    <section className="container">
      <div className={s.DomainOrSkillIntroBlock}>
        <IntroBlockHeader name={name} icon={icon} />
        <IntroBlockFooter
          name={name}
          clientReviewsCount={clientReviewsCount}
          developersCount={developersCount}
          rating={rating}
        />
      </div>
    </section>
  )
}
